var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-cs btn-rnd mt-2",attrs:{"tabindex":"0","role":"button"},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.show()},"click":function($event){return _vm.show()}}},[_vm._v("Book Now "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }